enquire.register("screen and (min-width: 53em)", {
    match : function() {
        const titleblock = document.querySelector('h1');
       // document.querySelector(".hide-mobile.block-title").appendChild(titleblock);
    },
    unmatch : function() {
    }
});
enquire.register("screen and (max-width: 53em)", {
    match : function() {
        const titleblock = document.querySelector('h1');
        document.querySelector(".onmobile.block-title").appendChild(titleblock);
    },
    unmatch : function() {

    }
});